import { ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { ModalStates } from '@/types/modal/modal.enum';
import OpenCloseAppHandler from '@/plugins/open-close-app-handler';
import store from '@/store';

export default class ModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	public mounted(): void {
		this.prepareModal();
		void OpenCloseAppHandler.openApp();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	public closeModal(): void {
		store.mutations.setModalState(ModalStates.INACTIVE);
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'GeotargetingModalWrapper',
			destroyOnClose: true,
			onClose: this.closeModal.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}
}
